import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
export type JobSeekerProfileFragment = { __typename?: 'JobSeekerProfilePayload', profile?: { __typename?: 'JobSeekerProfile', accountKey?: string | null, subscription?: { __typename?: 'JobSeekerProfileSubscription', status?: Types.JobSeekerProfileSubscriptionStatus | null } | null, jsProPremiumAccess?: { __typename?: 'JsProPremiumAccess', applicantInsights?: { __typename?: 'JsProPremiumAccessResult', access?: Types.JsProPremiumAccessStatus | null } | null } | null } | null };

export const JobSeekerProfileFragmentDoc = gql`
    fragment JobSeekerProfile on JobSeekerProfilePayload {
  profile {
    accountKey
    subscription {
      status
    }
    jsProPremiumAccess {
      applicantInsights {
        access
      }
    }
  }
}
    `;